import {
  Avatar,
  Checkbox,
  Form,
  Input,
  Pagination,
  PaginationProps,
  Tooltip,
} from "antd";
import "./style.scss";
import { useContext, useEffect, useState } from "react";
import { IoMdAdd } from "react-icons/io";
import Spinner from "../../../../../common/components/Spinner/Spinner";
import {
  generateColorArray,
  getNumberOfALetter,
} from "../../../../../utilities/random_color";
import { useQueryStaffPostForSelect } from "../../../../../common/hooks/StaffPost";
import { useQueryStaffList } from "../../../../employess/staff/core/_hooks";
import { Loader } from "../../../../../common/components/Loader/Loader";
import { FormProvider } from "../../../../../common/provider/form/Form.provider";
import { SimpleInput } from "../../../../../common/components/simpleInput";
import { getFirstCharOfAstring } from "../../../../../utilities/string";
import CustomModal from "../../../../../common/components/Modal/CustomModal";
import { CustomDrawer } from "../../../../../common/components/Drawer/CustomDrawer";
import { ModelList } from "./ModelList";
import { PlanningContext } from "./PlanningForm";
import { FormatDate } from "../../../../../utilities/formatDate";
import { StaffService } from "../../../../employess/staff/core/_request";
import { HttpStatusCode } from "axios";
import { SearhcInput } from "../../../../../common/components/searchInput/SearhcInput";
import { OperationContext } from "../CreateOperation";
import { CiCalendarDate } from "react-icons/ci";
import { StaffPostService } from "../../../../../common/services/staffPost.request";
import { PlanningConstant } from "../../../core/_constant";
import dayjs from "dayjs";

type NewTeamType = {
  onClose: () => void;
  onSuccess?: () => void;
  type?: any;
  initialValue?: any;
  index?: number;
  teamType: string;
};

const COLORS = generateColorArray(50);

const INITIAL_PAGINATION = {
  page: 1,
  itemsPerPage: 10,
};

const showTotal: PaginationProps["showTotal"] = (total: number) =>
  `Total ${total}`;

export const NewTeam = ({
  onClose,
  onSuccess,
  type,
  initialValue,
  index,
  teamType,
}: NewTeamType) => {
  const [form] = Form.useForm();

  const { defaultWorkTimes, initialValue: operationData } =
    useContext(OperationContext);
  const { handleSetTeamValue } = useContext(PlanningContext);

  // const { data: staffs, isLoading: isLoadingStaff } = useQueryStaffList();

  const [isOpenModalUser, setIsOpenModalUser] = useState<boolean>(false);
  const [selectedStaffPost, setSelectedStaffPost] = useState<any>();
  const [initialState, setInitialState] = useState<any>({});
  const [selectedStaff, setSelectedStaff] = useState<Array<any>>([]);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);
  const [isOpenModelDrawer, setIsOpenModelDrawer] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>();
  const [isLoadingStaff, setIsLoadingStaff] = useState<boolean>(false);
  const [staffs, setStaffs] = useState<Array<any>>([]);
  const [staffsTotal, setStaffsTotal] = useState<number>(0);
  const [paginationsStaff, setPaginationStaff] = useState(INITIAL_PAGINATION);
  const [isLoadingStaffPost, setIsLoadingStaffPost] = useState<boolean>(false);
  const [staffPost, setStaffPost] = useState<any[]>([]);

  useEffect(() => {
    handleInitialState();
  }, []);

  useEffect(() => {
    if (!isOpenModalUser) {
      setPaginationStaff(INITIAL_PAGINATION);
    }
  }, [isOpenModalUser]);

  useEffect(() => {
    isOpenModalUser &&
      selectedStaffPost &&
      getAllStaffsForList({ ...paginationsStaff });
  }, [paginationsStaff, selectedStaffPost, isOpenModalUser]);

  useEffect(() => {
    if (initialValue) {
      setSelected(initialValue);
    }
  }, [initialValue]);

  useEffect(() => {
    setInitialState((prev: any) => ({
      ...prev,
      operationCategory: type?.value,
    }));
  }, [type]);

  useEffect(() => {
    if (selected) {
      form.setFieldValue("name", selected?.name);
    } else {
      form.setFieldValue("name", "Equipe 1");
    }
    handleSetStaffPostValue();
    if (selected) {
      setInitialState((prev: any) => ({
        "@id": selected?.["@id"],
        id: selected?.["id"],
        ...prev,
      }));
    }
  }, [staffPost, selected]);

  useEffect(() => {
    if (teamType) {
      let params: any = {
        departmentType: "EXPLOITATION",
      };
      if (teamType === PlanningConstant.TEAM_STORAGE_ID) {
        params = {
          ...params,
          exploitationType: "INTERNAL",
        };
      } else {
        params = {
          ...params,
          exploitationType: "EXTERNAL",
        };
      }

      getStaffPosts(params);
    }
  }, [teamType]);

  const getStaffPosts = async (params?: any) => {
    try {
      setIsLoadingStaffPost(true);
      const res = await StaffPostService.getAllStaffPostSelect(params);
      if (res?.status === HttpStatusCode.Ok) {
        if (Array.isArray(res?.data?.member)) setStaffPost(res?.data?.member);
      }
    } catch (_: any) {
    } finally {
      setIsLoadingStaffPost(false);
    }
  };

  const getAllStaffsForList = async (params: any) => {
    const staffPostId = selectedStaffPost?.staffPost?.id;
    const operationId = operationData?.id;

    if (staffPostId && operationId) {
      try {
        setStaffs([]);
        setIsLoadingStaff(true);
        const res = await StaffService.getStaffForSelect({
          ...paginationsStaff,
          departmentType: "EXPLOITATION",
          staffPost: staffPostId,
          excludeOperation: operationId,
          teamsCreatedAt: dayjs().format("YYYY-MM-DD"),
          currentTeam: initialValue?.id,
          ...params,
        });
        if (res?.status === HttpStatusCode.Ok) {
          if (Array.isArray(res?.data?.member)) {
            setStaffs(res?.data?.member);
            setStaffsTotal(res?.data?.totalItems);
          } else {
            setStaffs([]);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoadingStaff(false);
      }
    }
  };

  const handleShowDrawerModel = () => {
    setIsOpenModelDrawer((prev: boolean) => !prev);
  };

  const handleInitialState = () => {
    handleSetStaffPostValue();
  };

  const handleSetStaffPostValue = (e?: any) => {
    e?.preventDefault();
    if (staffPost?.length) {
      if (!selected) {
        setInitialState((prev: any) => ({
          ...prev,
          modelTeamStaff: staffPost?.map((item: any) => ({
            staffPost: item,
            // staffPost: item?.["@id"],
            staff: [],
            name: item?.name,
          })),
        }));
      } else {
        setInitialState((prev: any) => ({
          ...prev,
          modelTeamStaff: staffPost?.map((item: any) => {
            const finded = selected?.modelTeamStaff?.find(
              (elem: any) => elem?.staffPost?.["@id"] === item?.["@id"]
            );
            if (!finded) {
              return {
                staffPost: item,
                staff: [],
                name: item?.name,
              };
            } else {
              return {
                ...finded,
                name: finded?.staffPost?.name,
              };
            }
          }),
        }));
      }
    }
  };

  const handleReset = (e?: any) => {
    e?.preventDefault();
    if (staffPost?.length) {
      setInitialState((prev: any) => ({
        ...prev,
        modelTeamStaff: staffPost?.map((item: any) => ({
          staffPost: item,
          // staffPost: item?.["@id"],
          staff: [],
          name: item?.name,
        })),
      }));
    }
  };

  const handleIsOpenModalUser = () => {
    setIsOpenModalUser((prev: boolean) => !prev);
  };

  const onCloseUserModal = () => {
    setIsOpenModalUser(false);
  };

  const handleClickOnStaffPost = (value: any) => {
    setSelectedStaffPost(value);
    setSelectedStaff(value?.staff);
    handleIsOpenModalUser();
  };

  const handleCheckUser = (e: any) => {
    if (
      selectedStaff?.length &&
      selectedStaff?.some((item) => item?.["@id"] == e?.["@id"])
    ) {
      const allStaffs = selectedStaff;
      setSelectedStaff(
        allStaffs.filter((item) => item?.["@id"] !== e?.["@id"])
      );
    } else {
      setSelectedStaff((prev: any) => [...prev, e]);
    }
  };

  const onClicOnValidateStaff = () => {
    setInitialState((prev: any) => ({
      ...prev,
      modelTeamStaff: prev?.modelTeamStaff?.map((staff: any) => {
        if (staff?.["staffPost"] === selectedStaffPost?.["staffPost"]) {
          return {
            ...staff,
            staff: selectedStaff,
          };
        } else {
          return staff;
        }
      }),
    }));
    onCloseUserModal();
    setSelectedStaff([]);
    // form.setFieldValue("name", "Equipe 1");
  };

  const onCloseHandler = (e?: any) => {
    e?.preventDefault();
    onClose();
    handleReset();
    form.setFieldValue("name", "Equipe 1");
    // handleSetStaffPostValue();
  };

  const handleGetValue = (value: any) => {
    setSelected(value);
    handleShowDrawerModel();
  };

  const handleClickOnSaveTeam = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const formatedData = {
        ...(index || index === 0 ? { index } : {}),
        ...values,
        ...initialState,
        teamShiftStart: FormatDate.dayjsTimeFormat(defaultWorkTimes?.[0]),
        teamShiftEnd: FormatDate.dayjsTimeFormat(defaultWorkTimes?.[1]),
        modelTeamStaff: initialState?.modelTeamStaff
          ?.filter((item: any) => item?.staff?.length)
          ?.map((item: any) => ({
            ...item,
          })),
      };

      handleSetTeamValue(formatedData, teamType);
      onCloseHandler();
      onSuccess && onSuccess();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <Loader isLoading={isLoadingStaffPost} />
      <FormProvider
        Form={Form}
        form={form}
        debug
        onFinish={(values: any) => {
          handleClickOnSaveTeam(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="team_form__container">
          <div className="team_form__title_wrapper">
            <div className="team_form__title_input">
              <SimpleInput
                Form={Form}
                name={"name"}
                // label="Equipe"
                rules={[
                  {
                    required: true,
                    message: "Ce champs est obligatoire",
                  },
                ]}
                customInput={<Input />}
              />
            </div>
            <div className="team_form__link" onClick={handleShowDrawerModel}>
              <span>Utiliser un model existant </span>
            </div>
          </div>
          <div className="">
            <div className="team_form__team_item">
              <table className="team_form__team_table">
                <tbody>
                  {initialState?.modelTeamStaff?.map(
                    (item: any, index: number) => (
                      <tr key={index}>
                        <td className="team_form__team_table_td">
                          <span className="team_form__team_item_title">
                            {item?.name}
                          </span>
                        </td>
                        <td className="team_form__team_table_td">
                          <Avatar.Group>
                            {item?.staff?.map((staffItem: any, key: number) => (
                              <Tooltip
                                title={staffItem?.fullname}
                                placement="top"
                                key={key}
                              >
                                <Avatar
                                  style={{
                                    backgroundColor:
                                      COLORS[
                                        getNumberOfALetter(
                                          getFirstCharOfAstring(
                                            staffItem?.fullname
                                          )
                                        )
                                      ],
                                  }}
                                >
                                  {getFirstCharOfAstring(staffItem?.fullname)}
                                </Avatar>
                              </Tooltip>
                            ))}

                            <Avatar
                              style={{
                                backgroundColor: "white",
                                borderColor: "rgb(208, 206, 206)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClickOnStaffPost(item)}
                            >
                              <IoMdAdd
                                style={{
                                  color: "rgb(208, 206, 206)",
                                  height: "20px",
                                  width: "20px",
                                }}
                              />
                            </Avatar>
                          </Avatar.Group>
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="team_form__footer_wrapper">
            <button
              className="team_form__button_secondary"
              onClick={onCloseHandler}
            >
              Annuler
            </button>
            <button
              className="team_form__button_secondary"
              onClick={handleReset}
            >
              Réinitialiser{" "}
            </button>
            <button
              className="team_form__button_primary"
              type="submit"
              disabled={isLoadingStaffPost}
            >
              {isLoadingSubmit ? <Spinner /> : "Confirmer"}
            </button>
          </div>
        </div>
      </FormProvider>
      {isOpenModalUser && (
        <CustomModal
          isOpen={isOpenModalUser}
          hanldeCloseModal={handleIsOpenModalUser}
          title={selectedStaffPost?.name}
          width={800}
        >
          <Loader isLoading={isLoadingStaff} />
          <SearhcInput
            onSearch={(e) => {
              setPaginationStaff((prev) => ({ ...prev, page: 1, fullname: e }));
            }}
          />
          <table className="team_form__team_table">
            <thead>
              <tr>
                <th className="team_form__team_table_th"> Nom </th>
                <th className="team_form__team_table_th">
                  <span className="flex gap-[10px] items-center">
                    {/* <CiCalendarDate className="w-[20px] h-[20px]" /> */}
                    <span>Absence à venir</span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {staffs?.map((item: any, key: number) => (
                <tr
                  key={key}
                  className={
                    item?.unavailableToday ? "team_form__team_row_disable" : ""
                  }
                >
                  <td className="team_form__team_table_td">
                    <Checkbox
                      checked={selectedStaff.some(
                        (s) => s?.["@id"] === item?.["@id"]
                      )}
                      disabled={item?.unavailableToday}
                      onChange={() => handleCheckUser(item)}
                    >
                      <span className="">{item?.fullname}</span>
                    </Checkbox>
                  </td>
                  <td className="team_form__team_table_td">
                    <div className="flex flex-col">
                      {item?.currentAbsence?.split(":")?.map((item: string) => (
                        <div className="text-nowrap">{item}</div>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="mt-4 d-flex w-100 justify-content-end">
            <Pagination
              className="w-full"
              simple
              showSizeChanger
              showTotal={showTotal}
              defaultCurrent={1}
              current={paginationsStaff?.page}
              pageSize={paginationsStaff?.itemsPerPage || 10}
              total={staffsTotal || 0}
              onChange={(page, itemsPerPage) => {
                setPaginationStaff({
                  page: page ?? 1,
                  itemsPerPage,
                });
              }}
            />
          </div>

          <div className="team_form__footer_wrapper mt-4">
            <button
              className="team_form__button_secondary"
              onClick={handleIsOpenModalUser}
            >
              Annuler
            </button>

            <button
              className="team_form__button_primary"
              onClick={onClicOnValidateStaff}
            >
              Valider{" "}
            </button>
          </div>
        </CustomModal>
      )}
      <CustomDrawer
        width={1000}
        title="Veuillez sélectionner le modèle qui vous convient."
        isShowCloseIcon={true}
        isOpen={isOpenModelDrawer}
        onClose={handleShowDrawerModel}
        position="bottom"
      >
        <ModelList onConfirm={handleGetValue} />
      </CustomDrawer>
    </div>
  );
};
